(function() {
  function init() {
    initCartDrawer();
  }

  function initCartDrawer() {
    function openCartDrawer() {
      const drawer = document.querySelector('[data-variant="treatment"] .cart-drawer');
      if (drawer) {
        drawer.classList.add("cart-drawer--active");
      }
    }

    function closeCartDrawer() {
      const drawer = document.querySelector('[data-variant="treatment"] .cart-drawer');
      if (drawer) {
        drawer.classList.remove("cart-drawer--active");
      }
    }

    async function updateCartDrawer() {
      const res2 = await fetch("/cart.js");
      const cart = await res2.json();

      const res = await fetch("/?section_id=cart-drawer");
      const text = await res.text();
      const html = document.createElement("div");
      html.innerHTML = text;

      const newBox = html.querySelector('[data-variant="treatment"] .cart-drawer-box');
      const existingBox = document.querySelector('[data-variant="treatment"] .cart-drawer-box');

      if (newBox && existingBox) {
        const simplyWidget = existingBox.querySelector('.simply-insurance.widget');
        const hadSimplyWidget = !!simplyWidget;

        if (simplyWidget) {
          simplyWidget.remove();
        }

        existingBox.innerHTML = newBox.innerHTML;

        if (simplyWidget) {
          const newPlaceholder = existingBox.querySelector('#cart-drawer-simply-placeholder');
          if (newPlaceholder) {
            newPlaceholder.appendChild(simplyWidget);
          }
        }

        addCartDrawerListeners();

        if (cart.item_count > 0 && !hadSimplyWidget && window.simplyInsurance?.cartReload) {
          requestAnimationFrame(() => window.simplyInsurance.cartReload(0));
        }
      }

      updateCartItemCounts(cart.item_count);
    }

    function updateCartItemCounts(count) {
      document.querySelectorAll(".cart-count").forEach((el) => {
        el.textContent = count;
      });

      const bubbles = document.querySelectorAll(".cart-count-bubble");
      bubbles.forEach((bubble) => {
        const span = bubble.querySelector('span[aria-hidden="true"]');
        if (span) {
          span.textContent = count;
        }
        if (count === 0) {
          bubble.style.display = 'none';
        } else {
          bubble.style.display = '';
        }
      });
    }

    function addCartDrawerListeners() {
      document.querySelectorAll('[data-variant="treatment"] .cart-drawer-quantity-selector button').forEach((button) => {
        button.addEventListener("click", async () => {
          const rootItem = button.closest(".cart-drawer-item");
          const line = rootItem.getAttribute("data-index");
          const currentQuantity = Number(button.parentElement.querySelector("input").value);
          const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
          const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

          if (newQuantity < 0) return;

          button.classList.add("loading");

          await fetch("/cart/change.js", {
            method: "post",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            body: JSON.stringify({ line, quantity: newQuantity }),
          });

          await updateCartDrawer();
          button.classList.remove("loading");
        });
      });

      document.querySelectorAll('[data-variant="treatment"] .cart-drawer-header-right-close, [data-variant="treatment"] .cart-drawer').forEach((el) => {
        el.addEventListener("click", closeCartDrawer);
      });

      const box = document.querySelector('[data-variant="treatment"] .cart-drawer-box');
      if (box) {
        box.addEventListener("click", (e) => e.stopPropagation());
      }

      initUpsellCarousel();
      initUpsellAddToCart();
    }

    function initUpsellCarousel() {
      const track = document.querySelector('.upsell-carousel-track');
      const prevBtn = document.querySelector('.upsell-nav-prev');
      const nextBtn = document.querySelector('.upsell-nav-next');
      if (!track || !prevBtn || !nextBtn) return;

      let currentIndex = 0;
      const items = track.querySelectorAll('.upsell-carousel-item');
      const totalItems = items.length;

      function updateCarousel() {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex === totalItems - 1;
      }

      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
        }
      });

      nextBtn.addEventListener('click', () => {
        if (currentIndex < totalItems - 1) {
          currentIndex++;
          updateCarousel();
        }
      });

      updateCarousel();
    }

    function initUpsellAddToCart() {
      document.querySelectorAll('.upsell-add-button').forEach(button => {
        if (button.hasUpsellListener) return;
        button.hasUpsellListener = true;

        button.addEventListener('click', async (e) => {
          const clickedButton = e.currentTarget;
          const productId = clickedButton.getAttribute('data-product-id');
          let variantId = clickedButton.getAttribute('data-variant-id');

          if (!variantId && productId) {
            const select = document.querySelector(`.upsell-variant-select[data-product-id="${productId}"]`);
            if (select) variantId = select.value;
          }

          if (!variantId) return;

          clickedButton.classList.add('loading');

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', 1);

          await fetch('/cart/add', { method: 'POST', body: formData });
          await updateCartDrawer();

          clickedButton.classList.remove('loading');
          initUpsellCarousel();
          initUpsellAddToCart();
        });
      });
    }

    addCartDrawerListeners();
  }

  init();
})();
